import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import WhyChoose from '../components/WhyChoose';

function HomePage({ scrollToSection }) {
  return (
    <>
      <Hero scrollToSection={scrollToSection} />
      <About />
      <WhyChoose />
    </>
  );
}

export default HomePage;